import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { FlightFeatureConfig } from '../../../types/insurances/FlightFeatureConfig';
import { flight as base } from './base';
import { flight as HU } from './HU';

export const flightConfig: InsuranceIndex<FlightFeatureConfig> = { base, HU };
